/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgPinBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.40209 14.5977L3 21M6.35834 9.4274C6.20007 9.52026 6.06521 9.64819 5.96412 9.80133C5.86303 9.95448 5.79841 10.1288 5.77524 10.3108C5.75206 10.4928 5.77094 10.6778 5.83042 10.8514C5.8899 11.025 5.9884 11.1826 6.11835 11.3122L12.6884 17.8825C12.818 18.0124 12.9756 18.1109 13.1492 18.1704C13.3228 18.2299 13.5077 18.2488 13.6897 18.2256C13.8718 18.2024 14.0461 18.1378 14.1992 18.0367C14.3524 17.9356 14.4803 17.8007 14.5731 17.6425C15.3513 16.3036 15.5834 14.7162 15.2211 13.2105L20.444 9.88659C20.5957 9.79016 20.7237 9.66091 20.8187 9.50838C20.9136 9.35585 20.9732 9.18394 20.9928 9.00534C21.0125 8.82673 20.9918 8.64599 20.9322 8.47645C20.8727 8.30692 20.7758 8.15292 20.6488 8.02582L15.9747 3.3515C15.8476 3.22445 15.6937 3.12754 15.5242 3.06794C15.3547 3.00834 15.174 2.98757 14.9954 3.00715C14.8168 3.02673 14.6449 3.08616 14.4923 3.18107C14.3397 3.27598 14.2105 3.40394 14.114 3.5555L10.7901 8.77941C9.28452 8.41707 7.69718 8.64916 6.35834 9.4274Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgPin = wrapIcon(SvgPinBase);
export default SvgPin;
